export enum RescheduleStatus {
  AwaitingPilot = 'Awaiting pilot',
  AwaitingClient = 'Awaiting client',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Skip = 'Skip',
}
